import { createStore } from "vuex";

import conversation from "./modules/conversation";
import customer from "./modules/customer";
import messages from "./modules/messages";
import options from "./modules/options";
import settings from "./modules/settings";

const store = createStore({
  modules: {
    customer,
    conversation,
    messages,
    settings,
    options
  }
});

export default store;
